import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Card, Button } from 'flowbite-react';
import { FaCalendarAlt, FaEnvelope, FaNewspaper, FaUser } from 'react-icons/fa';
import axios from 'axios';
import { FaGoogle, FaMicrosoft, FaYahoo, FaCopy } from 'react-icons/fa';
import { IoCreate } from 'react-icons/io5';
import { ClipLoader } from 'react-spinners';
import { useAuth0 } from "@auth0/auth0-react";
import moment from 'moment';
function LeadPage() {
  const { id } = useParams(); // Get listing _id from the URL
  const [lead, setLead] = useState(null); // State to hold the fetched listing
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state
  const [isOffcanvasOpen, setIsOffcanvasOpen] = useState(false); // Offcanvas state
  const [replyContent, setReplyContent] = useState(''); // Reply content state
  const [generatedDraft, setGeneratedDraft] = useState(''); // Generated email draft state
  const [loadingEmail, setLoadingEmail] = useState(false); // Loading state for email generation
  const { user } = useAuth0();
  const [userData, setUserData] = useState(null);
  const [matchScore, setMatchScore] = useState(null);
  const [explanation, setExplanation] = useState(null);

  const handleOpenOffcanvas = () => {
    setIsOffcanvasOpen(true);
  };

  const handleCloseOffcanvas = () => {
    setIsOffcanvasOpen(false);
  };

  useEffect(() => {
    const fetchListing = async () => {
      try {
        setLoading(true);
        // Pass the user._id as a query parameter
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/listings/${id}`, {
          params: {
            userId: user.sub  // Pass user._id (user.sub) here as userId
          }
        });
        setLead(response.data);
      } catch (err) {
        setError("Failed to load listing.");
      } finally {
        setLoading(false);
      }
    };
  
    const fetchUserData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/user-settings`, {
          params: {
            sub: user.sub
          }
        });
        setUserData(response.data);
        const responseExplanation = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/explanation`, {
          params: {
            userId: response.data._id,
            listingId: id
          }
        });
        setMatchScore(responseExplanation.data.score);
        setExplanation(responseExplanation.data.explanation);
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };
  
    fetchListing();
    if (user) {
      fetchUserData();
    }
  }, [id, user]); // The user dependency ensures the hook runs when the user changes
  // The user dependency ensures the hook runs when the user changes
  

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;
  if (!lead) return <p>Listing not found.</p>;

  const generateContent = async (reply, expertise, listing) => {
    setLoadingEmail(true);
    console.log(
        'the reply', reply, '\n', 'the expertise', expertise, '\n', 'the listing', listing
    )

    try {
      const response = await axios.post(`${process.env.REACT_APP_MATCHING_BACKEND_URL}/generate-email`, {
        reply: reply,
        expertise: expertise,
        listing: listing.description
      });
      const { emailDraft } = response.data;
      setGeneratedDraft(emailDraft); // Set the generated draft in state
    } catch (error) {
      console.error('Error generating content:', error);
      setGeneratedDraft('Failed to generate draft.');
    }

    setLoadingEmail(false);
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <Card className="max-w-1xl mx-auto">
        <h1 className="text-3xl font-bold mb-4">{lead.title}</h1>

        <div className="mb-6">
          <p className="text-xl font-semibold">{lead.journalist || 'N/A'}</p>
          <p className="text-gray-500">{lead.publication || 'N/A'}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <div className="flex items-center">
            <FaEnvelope className="w-5 h-5 mr-2 text-blue-600" />
            <a href={`mailto:${lead.email}`} className="text-blue-600 hover:underline">{lead.email || 'N/A'}</a>
          </div>
          <div className="flex items-center">
            <FaCalendarAlt className="w-5 h-5 mr-2 text-green-600" />
            Deadline: {lead.deadline && moment(lead.deadline, 'YYYY-MM-DD').isValid()
                ? moment(lead.deadline).format('dddd, MMMM Do YYYY')
                : 'N/A'}          </div>
          <div className="flex items-center">
            <FaNewspaper className="w-5 h-5 mr-2 text-purple-600" />
            <span>{lead.publication || 'N/A'}</span>
          </div>
          <div className="flex items-center">
            <FaUser className="w-5 h-5 mr-2 text-red-600" />
            <span>{lead.journalist || 'N/A'}</span>
          </div>
        </div>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-2">Description</h2>
          <Card className="bg-gray-50">
            <p className="text-gray-700 leading-relaxed">{lead.description || 'N/A'}</p>
          </Card>
        </div>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-2 flex items-center">
            Match Explanation
            <span
              className={`ml-3 inline-block px-2 py-1 text-sm font-medium text-white rounded-full ${
                matchScore > 50 ? 'bg-green-500' : matchScore < 50 ? 'bg-red-500' : 'bg-gray-500'
              }`}
            >
              {matchScore !== null ? matchScore : 'N/A'}
            </span>
          </h2>
          <Card className="bg-gray-50">
            <p className="text-gray-700 leading-relaxed">{explanation || 'N/A'}</p>
          </Card>
        </div>
        <div className="flex flex-col sm:flex-row justify-between gap-4">
          <Button
            onClick={handleOpenOffcanvas}
            className="w-full p-3 sm:w-auto bg-gradient-to-r from-purple-500 to-blue-500 hover:from-purple-600 hover:to-blue-600 text-white font-bold py-2 px-4 rounded transition duration-300"
          >
            Contact Journalist
          </Button>

          {/* Offcanvas (Drawer) */}
          <div
            className={`fixed top-0 right-0 h-full bg-white shadow-lg z-50 transition-transform transform ${
                isOffcanvasOpen ? 'translate-x-0 w-full sm:w-3/5' : 'translate-x-full w-3/4'
            }`}
            >

            {/* Close Button */}
            <button
              onClick={handleCloseOffcanvas}
              className="absolute top-4 right-4 text-gray-500"
            >
              &times;
            </button>

            {/* Offcanvas Content */}
            <div className="p-6 max-h-full overflow-y-auto">
              <h2 className="text-2xl font-semibold mb-4">Pitch Generator <span className="bg-pink-100 text-pink-800 text-md font-medium px-2.5 py-0.5 rounded dark:bg-pink-900 dark:text-pink-300">BETA</span></h2>
              
              <div className="space-y-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-400">Listing Information</label>
                  <p className="mt-1 break-words text-sm text-gray-500 dark:text-gray-400">{lead.description}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-400">Match Information</label>
                  <p className="mt-1 break-words text-sm text-gray-500 dark:text-gray-400">{explanation ? explanation : 'Loading'}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-400">Your Expertise</label>
                  <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                  {userData && userData.expertise ? userData.expertise : 'Loading expertise...'}

                  </p>
                </div>
                <div>
                  <label htmlFor="content" className="block text-sm font-medium text-gray-700 dark:text-gray-400">Your Reply</label>
                  <textarea
                    id="content"
                    onChange={(e) => setReplyContent(e.target.value)}
                    value={replyContent}
                    placeholder="Put your drafted reply here. Then click generate."
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50 h-48 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                  />
                </div>

                {/* Display the generated draft */}
                {loadingEmail ? (
                  <div className="flex justify-center items-center mt-4">
                    <ClipLoader size={50} color="#000" />
                  </div>
                ) : (
                  generatedDraft && (
                    <div>
                      <label className="block text-sm font-medium text-gray-700 dark:text-gray-400">Generated Draft</label>
                      <textarea
                        id="generated-content"
                        value={generatedDraft}
                        readOnly
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50 h-48 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                      />
                    </div>
                  )
                )}
              </div>

              <div className="flex justify-between w-full items-center mt-4">
                {/* Email Service Buttons */}
                <div className="flex gap-4">
                        {/* Gmail */}
                        <a
                        href={`https://mail.google.com/mail/?view=cm&fs=1&to=&su=${encodeURIComponent("Generated Pitch")}&body=${encodeURIComponent(generatedDraft || "")}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`text-red-500 text-2xl hover:opacity-75 ${!generatedDraft ? "opacity-50" : ""}`}
                        >
                        <FaGoogle />
                        </a>
                        {/* Outlook */}
                        <a
                        href={`https://outlook.office.com/mail/deeplink/compose?subject=${encodeURIComponent("Generated Pitch")}&body=${encodeURIComponent(generatedDraft || "")}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`text-blue-600 text-2xl hover:opacity-75 ${!generatedDraft ? "opacity-50" : ""}`}
                        >
                        <FaMicrosoft />
                        </a>
                        {/* Yahoo */}
                        <a
                        href={`https://compose.mail.yahoo.com/?subject=${encodeURIComponent("Generated Pitch")}&body=${encodeURIComponent(generatedDraft || "")}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`text-purple-600 text-2xl hover:opacity-75 ${!generatedDraft ? "opacity-50" : ""}`}
                        >
                        <FaYahoo />
                        </a>
                        </div>


                <button
                  onClick={() => generateContent(replyContent, userData.expertise, lead)}
                  className={`px-4 py-2 bg-gradient-to-r from-green-400 to-blue-500 text-white rounded-md ${loadingEmail ? 'opacity-50 cursor-not-allowed' : ''}`}
                  disabled={loadingEmail}
                >
                  {loadingEmail ? 'Generating...' : 'Generate Draft'}
                </button>
              </div>
            </div>
          </div>

          {/* Overlay to close offcanvas when clicked outside */}
          {isOffcanvasOpen && (
            <div
              onClick={handleCloseOffcanvas}
              className="fixed inset-0 bg-gray-500 bg-opacity-50 z-40"
            ></div>
          )}

          <Link to="/dashboard">
            <Button color="gray" className="w-full p-3 sm:w-auto bg-gradient-to-r from-gray-500 to-gray-600 text-white font-bold py-2 px-4 rounded transition duration-300">
              Back to Leads
            </Button>
          </Link>
        </div>
      </Card>
    </div>
  );
}

export default LeadPage;
